import { ref, watch, computed } from "@vue/composition-api";
import store from "@/store";

// Notification
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import ability from "@/libs/acl/ability";

export default function useMembershipLogsList() {
  // Use toast
  const toast = useToast();

  const refMembershipLogsListTable = ref(null);

  //Filter
  const companyFilter = ref(1);

  // Table Handlers
  const tableColumns = [
    // { key: "id", label: "編號", sortable: true },
    { key: "supplier.company_name_cn", label: "放債人名稱" },
    { key: "amount", label: "實收金額" },
    { key: "actual_amount", label: "轉入 X Coin 金額" },
    { key: "old_membership_expiry_date", label: "舊會員到期日"},
    { key: "new_membership_expiry_date", label: "新會員到期日"},
    { key: "old_search_limit", stickyColumn: true, label: "舊剩餘免費搜尋次數" },
    { key: "new_search_limit", label: "新剩餘免費搜尋次數" },
    { key: "free_limit_increase", label: "增加免費搜尋次數"},
    { key: "remark", label: "備註"},
    { key: "admin.name", label: "管理員" },
    { key: "created_at", label: "創建時間", sortable: true },
    // { key: "mobile", label: "手提電話" },
    // { key: "email", label: "電郵地址" },
    // { key: "moneylender_number", label: "放債人號碼", sortable: true },
  ];
  const perPage = ref(10);
  const totalMembershipLogs = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref("");
  const sortBy = ref("id");
  const isSortDirDesc = ref(true);
  const membershipLogsList = ref([])

  const dataMeta = computed(() => {
    const localItemsCount = refMembershipLogsListTable.value
      ? refMembershipLogsListTable.value.localItems.length
      : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalMembershipLogs.value,
    };
  });

  const refetchData = () => {
    refMembershipLogsListTable.value.refresh();
  };

  watch(
    [currentPage, perPage, searchQuery, companyFilter],
    () => {
      refetchData();
    }
  );

  const fetchMembershipLogs = (ctx, callback) => {
    store
      .dispatch("app-member/fetchMembershipLogs", {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        company_bit: companyFilter.value
      })
      .then((response) => {
        const { supplier_membership_logs, total } = response.data;
        callback(supplier_membership_logs);
        membershipLogsList.value = supplier_membership_logs
        totalMembershipLogs.value = total;
      })
      .catch((err) => {
        console.log(err);
        toast({
          component: ToastificationContent,
          props: {
            title: "Error fetching membership logs list",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      });
  };

  const companyOptions = [
    {id: 1, name: '公司'},
    {id: 0, name: '街客'},
    {id: null, name: '全部'}
  ]

  return {
    fetchMembershipLogs,
    tableColumns,
    perPage,
    currentPage,
    totalMembershipLogs,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refMembershipLogsListTable,
    ability,
    membershipLogsList,
    refetchData,
    companyFilter,
    companyOptions
  };
}
